var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoDownloadNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_418_96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 54.2233,
    height: 54.2233,
    rx: 4.33787,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2844 40.1866H30.7472C30.728 39.9749 30.7216 39.7631 30.7216 39.545C30.7216 34.6809 34.6808 30.7216 39.5449 30.7216C39.7631 30.7216 39.9749 30.728 40.1866 30.7472V17.2845C40.1866 16.0267 39.1599 15 37.9022 15H17.2844C16.0267 15 15 16.0267 15 17.2845V37.9022C15 39.1599 16.0267 40.1866 17.2844 40.1866ZM23.4383 21.7891C23.4383 21.5453 23.5859 21.3207 23.8105 21.2117C24.0351 21.1026 24.2982 21.141 24.4907 21.2951L31.5173 27.096C31.6649 27.2179 31.7483 27.404 31.7483 27.5966C31.7483 27.7826 31.6649 27.9687 31.5173 28.0906L24.4907 33.8916C24.3752 33.9878 24.2276 34.0391 24.08 34.0391C23.9902 34.0391 23.8939 34.0135 23.8105 33.975C23.5859 33.8659 23.4383 33.6413 23.4383 33.3975V21.7891Z",
    fill: "#006AB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5438 32.0055C35.3856 32.0055 32.0039 35.3872 32.0039 39.5454C32.0039 43.7036 35.3856 47.0854 39.5438 47.0854C43.7021 47.0854 47.0838 43.7036 47.0838 39.5454C47.0838 35.3872 43.7021 32.0055 39.5438 32.0055ZM41.8686 41.5789L39.9982 43.4493C39.939 43.5088 39.8678 43.556 39.7888 43.5887C39.7104 43.6211 39.6272 43.6381 39.5437 43.6381C39.4602 43.6381 39.377 43.6211 39.2986 43.5887C39.2197 43.5561 39.1485 43.5088 39.0892 43.4493L37.2188 41.5789C36.9682 41.3283 36.9682 40.9222 37.2188 40.6715C37.4695 40.4209 37.8755 40.4209 38.1262 40.6715L38.902 41.4473V36.0938C38.902 35.7391 39.189 35.4521 39.5437 35.4521C39.8984 35.4521 40.1854 35.7391 40.1854 36.0938V41.4473L40.9612 40.6715C41.2119 40.4209 41.618 40.4209 41.8686 40.6715C42.1193 40.9222 42.1193 41.3283 41.8686 41.5789Z",
    fill: "#006AB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_418_96",
    x: 0,
    y: 0,
    width: 62.2234,
    height: 62.2233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_418_96"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_418_96",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDownloadNewIcon);
export default __webpack_public_path__ + "static/media/videoDownloadNewIcon.df0478ca491dd14c849b81c7e1c24292.svg";
export { ForwardRef as ReactComponent };